import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * OrbitMarkdown — bare-bones markdown renderer for Orbit's chat replies.
 *
 * Why not reuse the shared MarkdownRenderer? Because MarkdownRenderer applies
 * its OWN Tailwind classes to every element (`<h2 className="text-[15px]
 * font-semibold mb-1.5 mt-3 text-gray-900">`). Those inline classes win on
 * specificity, so the polished `.orbit-dock-prose` typography we want for
 * Orbit's voice gets stripped of its hierarchy — bold-label-followed-by-text
 * looks visually inline because every weight is similar.
 *
 * This component renders the bare HTML semantics (`<h1>`, `<h2>`, `<p>`,
 * `<strong>`, `<ul>`, `<ol>`, `<li>`, `<blockquote>`, `<code>`, `<pre>`,
 * `<a>`, `<table>`, etc.) with ZERO inline classes. The parent's
 * `.orbit-dock-prose` CSS owns all visual decisions — heading hierarchy,
 * gradient bar accents, custom bullets, lead-paragraph rhythm, callouts.
 *
 * The only override is `<a target="_blank">` for safe link handling.
 */

export interface OrbitMarkdownProps {
  content: string;
}

const OrbitMarkdown: React.FC<OrbitMarkdownProps> = ({ content }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default OrbitMarkdown;
